export default "__VITE_ASSET__4NSHz7e6__"